var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRank = function SvgRank(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    fill: "currentcolor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m30.8 6.8-11-6-11.1 6 1.5 2.9 9.5-5.3 9.5 5.3 1.6-2.9Zm0 8.7-11-6.1-11.1 6 1.5 3 9.5-5.3 9.5 5.2 1.6-2.8Zm-10.8 5 2.2 6.4c0 .2.1.2.3.2h6.8c.3 0 .4.4.2.5l-5.6 4c0 .2-.1.3 0 .4l2 6.5c.2.3-.2.5-.4.4l-5.6-4a.2.2 0 0 0-.3 0l-5.6 4c-.3.2-.6 0-.5-.3l2.1-6.5v-.3l-5.6-4c-.3-.2-.1-.6.2-.6H17l.3-.2 2.1-6.5c.1-.4.5-.4.6 0Z"
  })));
};
export default SvgRank;